import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon, Input } from '@ibk/shared-ui';
import styles from './BeneficiarySearchInput.module.css';
export function BeneficiarySearchInput({ value = '', onChange, testIdIdentifier, debounceDelay = 1000, }) {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState(value);
    const previousValueRef = useRef(value);
    const isUserInputRef = useRef(false);
    useEffect(() => {
        if (value !== previousValueRef.current && !isUserInputRef.current) {
            setSearchValue(value);
            previousValueRef.current = value;
        }
    }, [value]);
    useEffect(() => {
        if (!isUserInputRef.current) {
            return;
        }
        const timer = setTimeout(() => {
            onChange(searchValue);
            isUserInputRef.current = false;
        }, debounceDelay);
        return () => clearTimeout(timer);
    }, [searchValue, onChange, debounceDelay]);
    const handleChange = (e) => {
        isUserInputRef.current = true;
        setSearchValue(e.target.value);
    };
    return (_jsx(Input, { placeholder: t('beneficiary-filter.search.placeholder'), value: searchValue, onChange: handleChange, dataTestId: `input${testIdIdentifier}Search`, size: 'small', leftElement: _jsx(Icon, { name: 'search', className: styles.searchIcon }), className: styles.searchInput, containerClassName: styles.searchInputContainer }));
}
